import { apiRequest } from "../api";

export const getCoupons = () => apiRequest("/coupons", "GET");
export const saveCoupon = (endpoint: string, method: string, payload: unknown) =>
  apiRequest(endpoint, method, payload);
export const deleteCoupon = (id: string) => apiRequest(`/coupons/${id}`, "DELETE");
